import { createSvgIcon } from "@mui/material";

export const ArrowBackIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.25 12.2754L19.25 12.2754" stroke="#149C84" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.2998 18.299L4.2498 12.275L10.2998 6.25" stroke="#149C84" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
  "ArrowBackIcon"
)